import { injectable } from "inversify";

import * as Api from "../constants/ApiUrlConstants"
import container from "../wires/Bootstrapper";
import SERVICE_IDENTIFIER from "../wires/Identifiers";

import { IApiService } from "./shared/ApiService";
import { IApiServiceExt } from "./shared/ApiServiceExt";

import { ClienteModel } from "../models/ClienteModels";
import { ProjectionPagedModel } from "../models/ProjectionPageModel";
import { SearcherBaseModel } from "../models/SearcherBaseModel";

export interface IClienteAdminService {
    Search(data: SearcherBaseModel): Promise<ProjectionPagedModel<ClienteModel>>
    GetById(Id: string): Promise<ClienteModel>
}

@injectable()
export class ClienteAdminService implements IClienteAdminService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    async Search(data: SearcherBaseModel): Promise<ProjectionPagedModel<ClienteModel>> {
        return await this.apiService.postAsync<ProjectionPagedModel<ClienteModel>>(Api.ClienteSearch, data)
    }

    async GetById(Id?: string): Promise<ClienteModel> {
        return await this.apiService.getAsync<ClienteModel>(Api.ClienteGetById, { Id })
    }
}